import gql from "graphql-tag";

export const fragment_OrganizationResponse = gql`
  fragment fragment_OrganizationResponse on OrganizationResponse {
    alias
    createdAt
    description
    logoAssetUrl
    name
    organizationId
    updatedAt
    roleByUser {
      title
    }
  }
`;
